import { ORDER_STATUS_BUCKET } from '@klareospace/pharos-lib-types';
import type { OrderStatus } from '@klareospace/pharos-lib-types';

import type { StatusBucketKey } from '../types/order.types';

/** Bucket keys whose label resolves via the shared `tCommon`; `DONE` stays local to `orders`. */
const STATUS_BUCKET_LABEL_OVERRIDES: Partial<Record<StatusBucketKey, string>> = {
  IN_PROGRESS: 'statuses.inProgress',
  PENDING: 'statuses.pending',
  TODO: 'statuses.todo',
};

// ─── Utils ────────────────────────────────────────────────────────────────────

/** Resolves which status bucket (PENDING/TODO/IN_PROGRESS/DONE) an order status belongs to. */
export function resolveStatusBucket(status: OrderStatus): StatusBucketKey {
  const entries = Object.entries(ORDER_STATUS_BUCKET) as [StatusBucketKey, readonly OrderStatus[]][];
  const match = entries.find(([, statuses]) => statuses.includes(status));
  if (!match) {
    throw new Error(`[resolveStatusBucket] Unknown order status '${status}' — not present in any ORDER_STATUS_BUCKET.`);
  }
  return match[0];
}

/** Resolves the status-bucket filter label. */
export function resolveStatusBucketLabel(
  key: StatusBucketKey,
  t: (key: string) => string,
  tCommon: (key: string) => string,
): string {
  const commonKey = STATUS_BUCKET_LABEL_OVERRIDES[key];
  return commonKey ? tCommon(commonKey) : t(`actionBar.filters.statusBuckets.${key}`);
}
